// Mock Meal Plans Data
// Extracted from MealPlanner.tsx

export interface MealPlan {
  id: string;
  user_id: string;
  date: string;
  meals: {
    breakfast?: any[];
    lunch?: any[];
    dinner?: any[];
    snacks?: any[];
  };
  daily_nutrition: {
    calories: number;
    protein: number;
    carbs: number;
    fat: number;
    fiber: number;
  };
  grocery_list_generated: boolean;
  notes?: string;
}

export const mockMealPlans: MealPlan[] = [
  {
    id: '1',
    user_id: 'user1',
    date: new Date().toISOString().split('T')[0],
    meals: {
      breakfast: [],
      lunch: [],
      dinner: [],
      snacks: []
    },
    daily_nutrition: {
      calories: 0,
      protein: 0,
      carbs: 0,
      fat: 0,
      fiber: 0
    },
    grocery_list_generated: false
  },
  {
    id: '2',
    user_id: 'user1',
    date: new Date(Date.now() + 24 * 60 * 60 * 1000).toISOString().split('T')[0],
    meals: {
      breakfast: [],
      lunch: [],
      dinner: [],
      snacks: []
    },
    daily_nutrition: {
      calories: 0,
      protein: 0,
      carbs: 0,
      fat: 0,
      fiber: 0
    },
    grocery_list_generated: false
  },
  {
    id: '3',
    user_id: 'user1',
    date: new Date(Date.now() + 2 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
    meals: {
      breakfast: [],
      lunch: [],
      dinner: [],
      snacks: []
    },
    daily_nutrition: {
      calories: 0,
      protein: 0,
      carbs: 0,
      fat: 0,
      fiber: 0
    },
    grocery_list_generated: false
  }
]; 